(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cfm"] && !Shopify.designMode) return;
  try {
    

/* -----------------------------------------------------
   CustomSelect – a form‑associated custom element
   ----------------------------------------------------- */
class CustomSelect extends HTMLElement {
  constructor () {
    super();
    this._listeners = [];
    this._events    = {};
  }

  /* ------------------------------------------------------ */
  /* Lifecycle                                              */
  /* ------------------------------------------------------ */
  connectedCallback () {
    try { this._mount(); } catch (err) { console.error(this.tagName, 'mount', err); }
  }
  disconnectedCallback () { this._unmount(); }

  /* ------------------------------------------------------ */
  /* Public API                                             */
  /* ------------------------------------------------------ */
  on (evt, fn) { (this._events[evt] ??= []).push(fn); }

  /* ------------------------------------------------------ */
  /* Private utilities                                      */
  /* ------------------------------------------------------ */
  _emit (evt, detail) { for (const f of this._events[evt] || []) f(detail); }
  _listen (el, evt, fn, opts) { el.addEventListener(evt, fn, opts); this._listeners.push({ el, evt, fn }); }
  _unmount () { for (const h of this._listeners) h.el.removeEventListener(h.evt, h.fn); this._listeners.length = 0; }

  /* ------------------------------------------------------ */
  /* Build component                                        */
  /* ------------------------------------------------------ */
  _mount () {
    /* 1 ▼ hidden native <select> ------------------------- */
    const rawOptions = [...this.querySelectorAll('option')];
    const placeholderText = (this.dataset.default || 'Choose an option').trim();

    this._native = document.createElement('select');
    Object.assign(this._native, {
      name     : this.getAttribute('name') || '',
      required : this.hasAttribute('required'),
      id       : this.getAttribute('id') || undefined
    });
    this._native.style.cssText = 'position:absolute;width:0;height:0;opacity:0;pointer-events:none;';

    // first option = inert placeholder (always selected at start)
    const ph = new Option(placeholderText, '', true, true);
    ph.disabled = true; ph.hidden = true;
    this._native.add(ph);

    rawOptions.forEach(o => this._native.add(o.cloneNode(true)));
    this.appendChild(this._native);
    rawOptions.forEach(o => o.remove()); // clean light‑DOM

    /* 2 ▼ visible scaffold ------------------------------ */
    this.setAttribute('role', 'combobox');
    this.setAttribute('aria-haspopup', 'listbox');
    this.dataset.open = 'false';
    this.tabIndex = 0;

    this._face  = Object.assign(document.createElement('span'), { className: 'custom-select__face', textContent: placeholderText });
    this._arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this._arrow.setAttribute('viewBox', '0 0 12 8');
    this._arrow.classList.add('custom-select__arrow');
    this._arrow.innerHTML = '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />';

    this._list = Object.assign(document.createElement('div'), {
      className: 'custom-select__list', role: 'listbox', tabIndex: -1
    });

    [...this._native.options].forEach(opt => {
      if (opt.disabled) return; // skip placeholder row
      const row = document.createElement('div');
      row.className     = 'custom-select__option';
      row.dataset.value = opt.value;
      row.textContent   = opt.textContent;
      this._list.appendChild(row);
    });

    this.append(this._face, this._arrow, this._list);

    /* 3 ▼ events ---------------------------------------- */
    // option click
    this._listen(this._list, 'click', e => {
      const row = e.target.closest('.custom-select__option');
      if (!row) return;
      e.stopPropagation();
      this._choose(row);
    });

    // face click toggles open/close
    this._listen(this, 'click', () => this._toggle());

    // keyboard nav
    this._listen(this, 'keydown', e => this._keys(e));

    // outside‑click close (comment to disable)
    this._listen(document, 'click', e => {
      if (!this.contains(e.target)) this._close();
    });

    this._validate(); // initial invalid state (placeholder)
  }

  /* ------------------------------------------------------ */
  /* Behaviour                                              */
  /* ------------------------------------------------------ */
  _open  () { if (!this.classList.contains('open')) { this.classList.add('open'); this.setAttribute('aria-expanded','true'); this.dataset.open='true'; this._list.querySelector('[aria-selected]')?.scrollIntoView({block:'nearest'});} }
  _close () { if ( this.classList.contains('open')) { this.classList.remove('open'); this.setAttribute('aria-expanded','false'); this.dataset.open='false'; } }
  _toggle() { (this.dataset.open==='true') ? this._close() : this._open(); }

  _choose (row) {
    // update selection visuals
    this._list.querySelector('[aria-selected]')?.removeAttribute('aria-selected');
    row.setAttribute('aria-selected','true');

    // propagate to native select & label
    this._face.textContent = row.textContent;
    this._native.value     = row.dataset.value;

    this._emit('change', this._native.value);
    this._native.dispatchEvent(new Event('change', { bubbles: true }));

    this._validate();
    this._close();
  }

  _validate () {
    const invalid = this._native.value === '';
    this._native.setCustomValidity(invalid ? 'Please choose a valid option' : '');
    this._face.classList.toggle('invalid', invalid);
    return !invalid;
  }

  _keys (e) {
    const rows = [...this._list.children]; if (!rows.length) return;
    const idx  = rows.findIndex(r => r.hasAttribute('aria-selected'));
    let next   = idx;
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); if (!this.classList.contains('open')) { this._open(); return; } next = (idx + 1) % rows.length; rows[next].click(); break;
      case 'ArrowUp'  : e.preventDefault(); if (!this.classList.contains('open')) { this._open(); return; } next = (idx - 1 + rows.length) % rows.length; rows[next].click(); break;
      case 'Enter'    :
      case ' '        : e.preventDefault(); this._toggle(); break;
      case 'Escape'   : this._close(); break;
    }
  }
}

if (!customElements.get('custom-select')) customElements.define('custom-select', CustomSelect);


(function(){
  document.addEventListener('DOMContentLoaded', function(){
    // 1. grab ?foo=bar&baz=qux
    const params = new URLSearchParams(window.location.search);

    // 2. for each param, find elements with data-{param}
    params.forEach((value, key) => {
      // Support Shopify contact[...] keys and plain keys
      const innerMatch = key.match(/^contact\[(.+?)\]$/);
      const inner = innerMatch ? innerMatch[1] : null;

      const candidates = [];
      // 1) Our data-* mapping using the clean inner key or the raw key when safe
      const dataKey = inner || key;
      if (/^[A-Za-z_][\w-]*$/.test(dataKey)) {
        candidates.push(() => document.querySelectorAll(`[data-${dataKey}]`));
      }

      // 2) Fallback: match by name="contact[foo]" or exact name
      const quoted = key.replace(/"/g, '\\"');
      candidates.push(() => document.querySelectorAll(`[name="${quoted}"]`));

      if (inner) {
        const quotedInner = `contact[${inner}]`.replace(/"/g, '\\"');
        candidates.push(() => document.querySelectorAll(`[name="${quotedInner}"]`));
      }

      let els = [];
      for (const get of candidates) {
        try {
          els = get();
          if (els && els.length) break;
        } catch { /* ignore invalid selector attempts */ }
      }

      els.forEach(el => {
        if ('value' in el) el.value = value;
        else el.textContent = value;

        // fire input/change so any bindings update
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();

// Range slider label update
/*
  Update the visible counter for each range slider.  Multiple sliders can be
  present on the page.  The span with data-from="ID" will mirror the
  current value.  The span with data-max="ID" holds the max value; it does
  not change, but we locate it here for completeness if future behaviour
  requires it.
*/
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    const sliders = document.querySelectorAll('[data-rangeslider]');
    sliders.forEach((slider) => {
      const fromLabel = document.querySelector(`[data-from="${slider.id}"]`);
      const maxLabel = document.querySelector(`[data-max="${slider.id}"]`);
      // If no explicit value is set on the slider then initialise it to the
      // midpoint between its min and max values so the thumb appears centred.
      if (!slider.getAttribute('value') && slider.min !== '' && slider.max !== '') {
        const minNum = parseFloat(slider.min);
        const maxNum = parseFloat(slider.max);
        if (!isNaN(minNum) && !isNaN(maxNum)) {
          slider.value = (minNum + maxNum) / 2;
        }
      }
      // helper to sync current value into the label
      function sync() {
        if (fromLabel) fromLabel.textContent = slider.value;
      }
      slider.addEventListener('input', sync);
      // initialise on page load
      sync();
    });
  });
})();

// Custom form validation.
(function () {
  "use strict";

  // Execute once the document is ready
  const ready = cb =>
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", cb)
      : cb();

  ready(() => {
    /* -------------------------------- constants ------------------------------- */
    const sections = document.querySelectorAll("[data-browser-validate]");
    const debugMode = new URLSearchParams(window.location.search).get("debug") === "1";
    const dlog = (...args) => {
      if (debugMode) console.log("[CFM]", ...args);
    };

    const escapeCss = (value => {
      if (window.CSS && typeof CSS.escape === "function") return CSS.escape;
      return (v = "") =>
        String(v).replace(/[^a-zA-Z0-9_-]/g, ch => `\\${ch.charCodeAt(0).toString(16)} `);
    })();

    const inputFor = el =>
      el.tagName.includes("-")
        ? el.querySelector("input,select,textarea") || el
        : el;

    const errorBoxFor = (form, id) =>
      form.querySelector(`[data-error-for="${escapeCss(id)}"]`);

    // Normalise UK mobile numbers: strip spaces/formatting and coerce 44 → +44
    const sanitiseUkMobile = value => {
      if (typeof value !== "string") return "";
      const rawDigits = value.replace(/\D/g, "");

      // Standardise prefixes after stripping all non‑digits
      if (rawDigits.startsWith("44")) {
        const rest = rawDigits.slice(2);
        return rest ? `+44${rest}` : "";
      }
      if (rawDigits.startsWith("0")) {
        return `0${rawDigits.slice(1)}`;
      }
      if (rawDigits.startsWith("7")) {
        return `0${rawDigits}`;
      }
      return rawDigits;
    };

    const mobileInputs = document.querySelectorAll("[data-uk-mobile]");
    mobileInputs.forEach(input => {
      const normalise = () => {
        const next = sanitiseUkMobile(input.value || "");
        if (input.value !== next) input.value = next;
      };
      input.addEventListener("input", normalise);
      input.addEventListener("blur", normalise);
      normalise();
    });

    /* --------------------------- iterate over sections -------------------------- */
    sections.forEach(section => {
      const form = section.querySelector("form");
      if (!form) return;

      // If the section wants native browser validation, enable it and bail out
      const wantsNative = (section.dataset.browserValidate || "").toLowerCase() === "true";
      if (wantsNative) {
        form.removeAttribute("novalidate");
        return;
      }

      // Otherwise use custom validation
      form.setAttribute("novalidate", "novalidate");

      const fields = Array.from(form.querySelectorAll("[data-validate]"));

      /* ------------------------- helper: mark validity ------------------------- */
      const setErrorState = (field, isError, message = "") => {
        const input = inputFor(field);

        // visual + data-error flag for CSS
        [input, field].forEach(el => {
          if (!el) return;
          el.classList.toggle("invalid", isError);
          el.dataset.error = String(isError);
        });

        // ARIA state
        if (input) input.setAttribute("aria-invalid", String(isError));

        // error message box
        const errorBox = errorBoxFor(form, input?.id || "");
        if (errorBox) {
          errorBox.dataset.error = String(isError);
          errorBox.textContent = isError ? message : "";
        }
      };

      const validateField = field => {
        const input = inputFor(field);
        if (!input) return true;

        // Custom checkbox group validation – require any to be checked
        if (input.dataset.checkboxGroup === "true") {
          const groupId = input.dataset.checkboxGroupId;
          let group = [];

          if (groupId) {
            group = form.querySelectorAll(
              `input[type="checkbox"][data-checkbox-group-id="${escapeCss(groupId)}"]`
            );
          }

          // Fallback to name match (legacy behaviour) if no group id is present
          if (!group.length) {
            const name = input.getAttribute("name");
            group = name
              ? form.querySelectorAll(`input[type="checkbox"][name="${escapeCss(name)}"]`)
              : [];
          }

          const anyChecked = Array.from(group).some(cb => cb.checked);
          setErrorState(field, !anyChecked, anyChecked ? "" : "Please select at least one option");

          // Keep peers in sync with the current validity state
          group.forEach(cb => {
            cb.classList.toggle("invalid", !anyChecked);
            cb.dataset.error = String(!anyChecked);
          });

          dlog("validate checkbox group", {
            id: input.id,
            groupId,
            names: Array.from(group).map(cb => cb.name),
            anyChecked
          });

          return anyChecked;
        }

        // UK mobile validation using our own normaliser + regex to avoid browser quirks
        if ("ukMobile" in input.dataset) {
          const next = sanitiseUkMobile(input.value || "");
          if (input.value !== next) input.value = next;

          const isUkMobile = /^(\+?447\d{9}|07\d{9})$/.test(next);
          input.setCustomValidity(
            isUkMobile ? "" : "Enter UK mobile number e.g. 07554202635 or +447554202635"
          );
          setErrorState(
            field,
            !isUkMobile,
            isUkMobile ? "" : input.validationMessage || "Enter a valid UK mobile number"
          );
          dlog("validate uk mobile", {
            id: input.id,
            raw: input.value,
            normalised: next,
            isUkMobile
          });
          return isUkMobile;
        }

        const valid = input.checkValidity();
        setErrorState(field, !valid, input.validationMessage || "");
        dlog("validate generic", {
          id: input.id,
          name: input.name,
          type: input.type,
          value: input.value,
          validity: input.validity,
          valid
        });
        return valid;
      };

      /* ---------------------- lazy per‑field blur validation --------------------- */
      const onBlur = evt => {
        const field = evt.currentTarget.closest("[data-validate]");
        // Only re‑validate if this field was previously flagged as invalid
        if (field && field.classList.contains("invalid")) {
          validateField(field);
        }
      };

      /* ------------------------------ submit logic ----------------------------- */
      /*
       * Intercept all form submissions.  We attach the listener in the
       * capturing phase (the third argument set to true) so that it runs
       * before any other submit handlers registered elsewhere in the theme
       * or by external scripts.  Once we have determined that the form is
       * invalid we stop propagation and prevent the default behaviour so no
       * other listener can trigger a submission.  When the form is valid we
       * call form.submit() directly to bypass any remaining submit
       * listeners, ensuring the form only submits when it passes our
       * validation criteria.
       */
      form.addEventListener(
        "submit",
        evt => {
          let allValid = true;
          fields.forEach(field => {
            const ok = validateField(field);
            allValid = allValid && ok;
          });
          dlog("submit validation result", { allValid });

          // If any error messages are present, the form is not valid.  This
          // additional check covers cases where a field was not marked with
          // data‑validate (for example, email inputs which are implicitly
          // required) but an error message was shown via the UI.  Without
          // this the form could submit despite visible errors.
          const visibleErrors = form.querySelectorAll(
            ".error_message[data-error='true']"
          );
          if (visibleErrors.length > 0) {
            allValid = false;
          }

          const anyInvalidClass = !!form.querySelector(".invalid");

          // Only proceed when every field is valid and no element has our invalid class.
          // We intentionally bypass form.checkValidity() because invisible captcha or
          // other injected fields can report invalid even when our inputs are fine.
          if (allValid && !anyInvalidClass) {
            dlog("submit: all valid (bypassing native check), letting submit/captcha run");
            return;
          }

          dlog("submit: blocking submit", {
            allValid,
            anyInvalidClass,
            nativeInvalidElement: (() => {
              const el = form.querySelector(":invalid");
              if (!el) return null;
              return {
                tag: el.tagName,
                id: el.id,
                name: el.getAttribute("name"),
                type: el.getAttribute("type"),
                value: "value" in el ? el.value : undefined,
                validity: el.validity ? {
                  valueMissing: el.validity.valueMissing,
                  typeMismatch: el.validity.typeMismatch,
                  patternMismatch: el.validity.patternMismatch,
                  tooShort: el.validity.tooShort,
                  tooLong: el.validity.tooLong,
                  rangeUnderflow: el.validity.rangeUnderflow,
                  rangeOverflow: el.validity.rangeOverflow,
                  stepMismatch: el.validity.stepMismatch,
                  customError: el.validity.customError,
                  valid: el.validity.valid
                } : null,
                required: el.required
              };
            })(),
            validity: fields.map(field => {
              const input = inputFor(field);
              return input
                ? {
                    id: input.id,
                    name: input.name,
                    type: input.type,
                    value: input.value,
                    validity: {
                      valueMissing: input.validity.valueMissing,
                      typeMismatch: input.validity.typeMismatch,
                      patternMismatch: input.validity.patternMismatch,
                      tooShort: input.validity.tooShort,
                      tooLong: input.validity.tooLong,
                      rangeUnderflow: input.validity.rangeUnderflow,
                      rangeOverflow: input.validity.rangeOverflow,
                      stepMismatch: input.validity.stepMismatch,
                      customError: input.validity.customError,
                      valid: input.validity.valid
                    },
                    minLength: input.minLength,
                    maxLength: input.maxLength,
                    pattern: input.pattern,
                    required: input.required,
                    dataError: field.dataset.error
                  }
                : { id: "(no input)" };
            })
          });

          // Block submit + other listeners when invalid
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          form.reportValidity?.();

          // Attach blur listeners only after the first failed submit so the user
          // can progressively fix errors.
          fields.forEach(field => {
            const target = inputFor(field);
            if (!target.__hasBlurValidation) {
              target.addEventListener("blur", onBlur, { passive: true });
              target.__hasBlurValidation = true;
            }
          });

          // Focus the first invalid field for accessibility
          const firstInvalid = fields.find(f => f.classList.contains("invalid"));
          if (firstInvalid) {
            const target = inputFor(firstInvalid) || firstInvalid;
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            target.focus?.({ preventScroll: true });
          }
        },
        true
      );
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-product-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // If you have any JavaScript for this section, add it here
  })();

  } catch(e) { console.error(e); }
})();
})();
